import Vue from "vue";
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import { mixinDevice } from "@/utils/mixin.js";
import SideMenuStudent from "../components/SideMenuStudent.vue";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { jumpMixins } from "@/utils/jumpMixins";
export default {
  name: "HomeLayout",
  mixins: [mixinDevice, jumpMixins],
  components: {
    Header: Header,
    SideMenuStudent: SideMenuStudent,
    Footer: Footer
  },
  data: function data() {
    return {
      bgUrl: "/assets/background.svg"
    };
  },
  created: function created() {
    var tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if (tenantConfig.homeBackground) {
      this.bgUrl = tenantConfig.themeConfig.homeBackground;
    }
    if (!Vue.ls.get(ACCESS_TOKEN)) {
      this.toLogin();
    }
  }
};